import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Logo from '../SmartEvacLogo.jpg';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useNavigate } from 'react-router-dom';
import { createUserWithEmailAndPassword } from "firebase/auth";
import { app, auth } from './Firebase.js';
import React, { useState } from 'react';
import axios from 'axios';


function Register() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [firebrig, setFireBrig] = useState(false);
  const [address, setaddress] = useState("");
  const [fname, setfname] = useState("");
  const [sname, setsname] = useState("");
  const [org, setorg] = useState("");
  const navigate = useNavigate();

  const apiUrl = "https://v33xbajfo4.execute-api.eu-west-2.amazonaws.com/deploy/send-email";

  const sendDataToApi = async () => {
    try {
      let organizationName;
      if (firebrig==true){
        organizationName  = "Fire Brigade";
      }else{
        organizationName = org;
      }
      const userData = {
        type: "registration",
        email: email,
        fname: fname,
        sname: sname,
        address:address,
        Orgname: organizationName,
      };

      console.log(userData);
      const response = await axios.post(apiUrl, userData);
      console.log('Data sent to API:', response.data);
    } catch (error) {
      console.error('Error sending data to API:', error);
    }
  };

  const signUp = async (e) => {
    e.preventDefault();
    try {
      await sendDataToApi();
      navigate('/registered');
    } catch (error) {
      console.error('Error signing up:', error);
    }
  };

  const handleReturn = (event) => {
    event.preventDefault();
    navigate('/');
  };

  const handleSetFireBrigade = () => {
    setFireBrig(true);
  };

  const handleSetOther = () => {
    setFireBrig(false);
  };

  return (
    <Container className= "main-page-content">
      <Row>
        <Col>
          <img className="app-logo" src={Logo} width="400" height="50" alt="Smart Evac Logo" />
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col xs={8} sm={8} md={8} lg={8}>
          <form className="loginForm" onSubmit={signUp}>
            <p className="Title">Join us now</p>
            <div className="form-group">
              <input
                type="text"
                name="fname"
                placeholder="Forename"
                onChange={(e) => setfname(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <input
                type="text"
                name="sname"
                placeholder="Surname"
                onChange={(e) => setsname(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label className="radio-label">
                <input
                  type="radio"
                  name="department"
                  value="fireBrigade"
                  className="radio"
                  onChange={handleSetFireBrigade}
                />
                <span className="radio-text">Fire Brigade</span>
              </label>
              <label className="radio-label">
                <input
                  type="radio"
                  name="department"
                  value="other"
                  className="radio"
                  onChange={handleSetOther}
                />
                <span className="radio-text">Other</span>
              </label>
            </div>
            <div className="form-group">
              <input
                type="text"
                name="Orgname"
                placeholder="if other state Organisation name"
                onChange={(e) => setorg(e.target.value)}
                disabled={firebrig}
              />
            </div>
            <div className="form-group">
              <input
                type="text"
                name="Address"
                placeholder="Address"
                onChange={(e) => setaddress(e.target.value)}
                disabled={firebrig}
              />
            </div>
            <div className="form-group">
              <input
                type="email"
                id="email"
                name="email"
                placeholder="Email"
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <input
                type="password"
                id="password"
                name="password"
                placeholder="Password"
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <button type="submit" className="login-button">
              Register
            </button>
          </form>
          <p className="SignUpIndicator">
            <span className="SignUpQuestion">Return to</span>
            <a href="#" onClick={handleReturn}>Login</a>
          </p>
        </Col>
      </Row>
    </Container>
  );
}

export default Register;
